<template>
  <div class="countdown">
    <div class="_countdown">
      <div class="countdownDays countdownWrapper">
        <div class="_countdownDays countdownNumber">{{countdownDays | two_digits}}</div>
        <div class="countdownLabel">days</div>
      </div>
      <div class="countdownHours countdownWrapper">
        <div class="_countdownHours countdownNumber">{{countdownHours | two_digits}}</div>
        <div class="countdownLabel">hrs</div>
      </div>
      <div class="countdownMins countdownWrapper">
        <div class="_countdownMins countdownNumber">{{countdownMins | two_digits}}</div>
        <div class="countdownLabel">mins</div>
      </div>
      <div class="countdownSecs countdownWrapper">
        <div class="_countdownSecs countdownNumber">{{countdownSecs | two_digits}}</div>
        <div class="countdownLabel">secs</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  data() {
    return {
      countdownProgress: 0,
      countdownDays: 0,
      countdownHours: 0,
      countdownMins: 0,
      countdownSecs: 0,
    };
  },
  methods: {
    countdownInit() {
      var timer;
      var now = new Date();
      var timeDiff = new Date("21 October 2025 23:59:59 GMT-07:00").getTime() - now.getTime();
      var seconds = Math.floor(timeDiff / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      var days = Math.floor(hours / 24);
      hours %= 24;
      minutes %= 60;
      seconds %= 60;
      if (days < 0) {
        days = hours = minutes = seconds = 0;
      }

      this.countdownDays = days;
      this.countdownHours = hours;
      this.countdownMins = minutes;
      this.countdownSecs = seconds;
      if (timeDiff <= 0) {
        clearTimeout(timer);
        return;
      }
      timer = setTimeout(this.countdownInit, 1000);
    },
  },
  filters:{
    two_digits(value){
      if(value.toString().length <= 1)
    {
        return "0"+value.toString();
    }
    return value.toString();
    }
  },
  mounted() {
    this.countdownInit();
    // this.countdownBarInit();
  }
};
</script>

<style lang="scss" scoped>
.countdown {
  position: relative;
  display: flex;
  justify-content: flex-start;
  line-height: 0px;
  width: 284px;
  margin-top: 25px;
  padding: 0;
  border-radius: 2px;
  padding-top: 12px;
  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: 4px;
    background: #092244;
  }
  @media (max-width: $md) {
    width: calc(380px / 1.5);
    height: calc(83px / 1.5);
    padding: 0;
    width: fit-content;
  }

  ._countdown{
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: center;
    height: 100%;
    width: fit-content;
    overflow: hidden;
  }

  .countdownWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    text-align: center;
    padding: 0 10px;
    height: 100%;
    width: 71px;
    .countdownNumber {
      @include nofex;
      font-size: 26px;
      letter-spacing: 0;
      line-height: 36px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #092244
    }
    .countdownLabel {
      @include nexaBold;
      font-size: 8px;
      line-height: 16px;
      text-transform: uppercase;
      color: #092244;
    }
    @media (max-width: $md) {
      width: calc(71px / 1.5);
      .countdownNumber {
        font-size: calc(50px / 1.5);
        line-height: calc(55px / 1.5);
      }
      .countdownLabel {
        font-size: 10px;
        line-height: 13px;
      }
    }
    &:last-child {
      margin-right: 0;
      border: none;

      .countdownNumber::after {
        display: none;
      }
    }
  }
}
</style>